export default {
	"distribution": {
		"distribution": "分配",
		"cancelDistribution": "撤销分配"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/distribution/distribution.js